import { mapPayerNameToCodeForDropdown } from "constants/practiceType";
import { IPracticeTypeSwitch } from "types/PracticeTypeSuggestion/PracticeTypeSuggestion";

/**
 * CLE-2971 — the words for an automatic Service Type switch. Shared by the notice beside the Service Type
 * dropdown and the toast `EligibilityButton` shows when a run in this page session switches.
 */
const MODALITY_WORDING: Record<IPracticeTypeSwitch["modality"], string> = {
  MRI: "an MRI",
  CT: "a CT scan",
  ULTRASOUND: "an ultrasound",
  XRAY: "an X-ray",
};

/** The Service Type dropdown's own label for a code; the bare code when the dropdown does not offer it. */
export const practiceTypeName = (code: string): string =>
  mapPayerNameToCodeForDropdown.find((option) => option.value === code)?.name ??
  `Service Type ${code}`;

export const buildPracticeTypeSwitchMessage = (
  practiceTypeSwitch: IPracticeTypeSwitch
): string =>
  `Service Type changed from ${practiceTypeName(
    practiceTypeSwitch.from
  )} to ${practiceTypeName(practiceTypeSwitch.to)} because this order has ${
    MODALITY_WORDING[practiceTypeSwitch.modality] ?? "a procedure"
  }.`;
